import type { SessionTypeKey } from '@/stores/sessionType'
import { SessionType } from '@/stores/sessionType'

import { AddOnsTheme } from '@/components/AddOnsSelection/types'

const DARK_THEME_KEYS: SessionTypeKey[] = [
  SessionType.EliteUnlimited,
  SessionType.ElitePlus,
  SessionType.Elite
]
const RIGHT_IMAGE_KEYS: SessionTypeKey[] = [
  SessionType.Legacy,
  SessionType.Standard,
  SessionType.Simple,
  SessionType.Basic
]

/** Derive the add-ons page theme from the session type key. */
export function deriveAddOnsTheme(key: SessionTypeKey): AddOnsTheme {
  return DARK_THEME_KEYS.includes(key) ? AddOnsTheme.Dark : AddOnsTheme.Light
}

/** Derive the first section image position from the session type key. */
export function deriveAddOnsImagePosition(key: SessionTypeKey): 'right' | undefined {
  return RIGHT_IMAGE_KEYS.includes(key) ? 'right' : undefined
}
